module.exports = __webpack_public_path__ + "static/img/alfamidi.2ba091c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alfamidi.png
// module id = Sr52
// module chunks = 1